"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _workOrderDetail = _interopRequireDefault(require("./components/workOrderDetail"));
var _permission = require("@/utils/permission");
var _directRefund = _interopRequireDefault(require("@/views/order/components/directRefund.vue"));
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _productEnums = require("@/enums/productEnums");
var _reservation = require("@/api/reservation");
var _dialogDispatch = _interopRequireDefault(require("./components/dialogDispatch"));
var _dialogReschedule = _interopRequireDefault(require("./components/dialogReschedule"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var tableFroms = {
  status: '0',
  dateLimit: '',
  orderNo: '',
  page: 1,
  limit: $constants.page.limit[0],
  serviceType: '',
  searchType: 'all',
  content: '',
  workOrderNo: ''
};
var _default = exports.default = {
  name: 'orderlistDetails',
  components: {
    dialogDispatch: _dialogDispatch.default,
    dialogReschedule: _dialogReschedule.default,
    DirectRefund: _directRefund.default,
    detailsFrom: _workOrderDetail.default
  },
  computed: {
    // 批量改派
    dispatch: function dispatch() {
      return (this.tableFrom.status == 2 || this.tableFrom.status == 3) && (0, _permission.checkPermi)(['merchant:workOrder:reassign']) && this.checkedIds.length > 0;
    },
    // 批量改约
    rescheduling: function rescheduling() {
      return (0, _permission.checkPermi)(['merchant:workOrder:updateAgreement']) && (this.tableFrom.status == 2 || this.tableFrom.status == 1) && this.checkedIds.length > 0;
    },
    // 是否能批量操作
    isBatch: function isBatch() {
      return this.checkedIds.length > 0 && Number(this.tableFrom.status) > 0 && Number(this.tableFrom.status) < 4 ? false : true;
    }
  },
  data: function data() {
    return {
      workOrderNo: '',
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      tableFrom: Object.assign({}, tableFroms),
      orderChartType: {},
      timeVal: [],
      fromType: [{
        value: 1,
        text: '上门服务'
      }, {
        value: 2,
        text: '到店服务'
      }],
      selectionList: [],
      type: 0,
      //订单类型
      OrderSecondTypeEnum: _productEnums.OrderSecondTypeEnum,
      checkedIds: [] //选中的id
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['mmerchant:workOrder:page:list'])) this.getList();
    if ((0, _permission.checkPermi)(['merchant:workOrder:status:num'])) this.getOrderStatusNum();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 派单
    handleDispatch: function handleDispatch(type) {
      this.$refs.dialogDispatchRef.openBox(type);
    },
    // 改约
    handleRescheduling: function handleRescheduling() {
      this.$refs.dialogRescheduleRef.openBox();
    },
    // 服务状态
    orderColorFilter: function orderColorFilter(status) {
      var statusMap = {
        3: '#0FC6C2',
        1: '#FF7D00',
        2: '#3491FA',
        4: '#CCCCCC',
        9: '#F56464'
      };
      return statusMap[status];
    },
    handleReset: function handleReset() {
      this.tableFrom.type = '';
      this.tableFrom.dateLimit = '';
      this.tableFrom.orderNo = '';
      this.tableFrom.workOrderNo = '';
      this.tableFrom.page = 1;
      this.tableFrom.content = '';
      this.tableFrom.searchType = 'all';
      this.tableFrom.serviceType = '';
      this.selectChange();
    },
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 详情
    onOrderDetails: function onOrderDetails(id) {
      this.workOrderNo = id;
      this.$refs.orderDetail.getDetail(id);
      this.$refs.orderDetail.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 备注
    handleOrderMark: function handleOrderMark(row) {
      var _this = this;
      this.$modalPrompt('textarea', '备注', row.remark, '工单备注').then(function (V) {
        (0, _reservation.workOrderMarkApi)({
          remark: V,
          workOrderNo: row.workOrderNo
        }).then(function () {
          _this.$message.success('操作成功');
          _this.getList();
        });
      });
    },
    // 完成工单
    handleForceFinish: function handleForceFinish(row) {
      var _this2 = this;
      this.$modalSure('确认强制完成工单吗？').then(function () {
        (0, _reservation.workOrderForceFinishApi)({
          workOrderNoList: [row.workOrderNo]
        }).then(function (res) {
          _this2.$message.success('完成工单成功');
          _this2.getList();
          _this2.getOrderStatusNum();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.workOrderNo);
      });
      this.checkedIds = data;
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 列表
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _reservation.workOrderListApi)(this.tableFrom).then(function (res) {
        _this3.tableData.data = res.list || [];
        _this3.tableData.total = res.total;
        _this3.listLoading = false;
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this4 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.status;
      (0, _reservation.workOrderStatusNumApi)(data).then(function (res) {
        _this4.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};